<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">merge</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Itens da nota ainda não foram associados</h2>
    <span class="modal-subtitle">NF-e {{ numeroNota }} · {{ data.nomeFornecedor }}@if (itensLabel) { · {{ itensLabel }}}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" aria-label="Fechar" (click)="cancelar()">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p class="mb-0">
    Esta nota está {{ statusLabel }}: os {{ itensTexto }} ainda não foram associados aos produtos do
    sistema. A tela abre na associação de itens — só depois de todos resolvidos o vínculo com o
    pedido de compra pode ser feito.
  </p>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button type="button" class="btn-primary" (click)="associarItens()">Associar itens da NF-e</button>
</mat-dialog-actions>
